import ApiService from "@services/apiService";

const ClubProfileRequestService = {
  getRequests: async (clubId, params = {}) => {
    const response = await ApiService.get(`/clubs/${clubId}/club_profile_requests`, { params });
    return response.data;
  },

  getRequest: async (clubId, requestId) => {
    const response = await ApiService.get(`/clubs/${clubId}/club_profile_requests/${requestId}`);
    return response.data;
  },

  transformShowData: (data) => {
    return {
      clubId: data.club_profile_request.club_id,
      aasm_state: data.aasm_state,
      status_text: data.status_text,
      clubName: data.club_profile_request.club_name,
      form_id: data.club_profile_request.form_id,
      request: {
        id: data.club_profile_request.id,
        description: data.club_profile_request.description,
        current_description: data.club_profile_request.current_description
      },
      request_histories: data.request_histories,
      permissions_for_user: data.permissions_for_user || [],
      created_at:     data.club_profile_request.created_at,
      created_at_fmt: data.club_profile_request.created_at_fmt,
      updated_at:     data.club_profile_request.updated_at,
      updated_at_fmt: data.club_profile_request.updated_at_fmt,
      submitted_by_name: data.submitted_by_name
    };
  }
};

export default ClubProfileRequestService;
